import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './shared/common/error-page/error-page.component';
import { AuthGuard } from './shared/gaurd/auth.guard';
import { AssignmentComponent } from './views/badeloft-pages/assignment/assignment.component';
import { CoreComponent } from './views/badeloft-pages/core/core.component';
import { DashboardComponent } from './views/badeloft-pages/dashboard/dashboard.component';
import { StatusComponent } from './views/badeloft-pages/status/status.component';
import { StockComponent } from './views/badeloft-pages/stock/stock.component';
import { LoginComponent } from './views/login/login.component';

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: 'login', component: LoginComponent, data: { title: "Login" } },
  { path: "error", component: ErrorPageComponent, data: { title: "Other Error" } },
  {
    path: 'bade-loft', component: CoreComponent, canActivate: [AuthGuard], data: { title: "" },
    children: [
      { path: '', loadChildren: () => import('./views/badeloft-pages/badeloft-pages.module').then(m => m.BadeloftPagesModule), data: { title: "Bade Loft" } },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
